import React from 'react';

import searchIcon from '../../assets/search-icon.png';

import './style.css';

const Search = ({ text, width = null, backgroundColor, setFunction }) => {
	return (
		<div className="search" style={{ width: width ? width : "100%", backgroundColor: backgroundColor ? backgroundColor : "white" }}>
			<img src={searchIcon} alt="search-icon" />
			<input onChange={(e) => setFunction(e.target.value)} type="text" placeholder={text} />
		</div>
	)
}

export default Search;